<script setup>
import VueCookieComply from "@/shared/VueCookieComply/VueCookieComply.vue";

/* Cookies */
const preferences = [
  {
    title: "Necesario",
    value: "strictly-necessary",
    isRequired: true,
    description:
      "Las cookies necesarias permiten que una página web sea funcional al activar características básicas como la navegación y el acceso a zonas seguras del sitio. Sin estas cookies, la página no podría funcionar correctamente.",
    items: [
      {
        label: "_cfuvid",
        value: "_cfuvid",
      },
      {
        label: "__cf_bm",
        value: "__cf_bm",
      },
      {
        label: "cookie-consent-analytics",
        value: "cookie-consent-analytics",
      },
    ],
  },
  {
    title: "Estadística",
    value: "analytics",
    description:
      "Las cookies estadísticas ayudan a los propietarios de sitios web a entender cómo interactúan los visitantes con las páginas, recopilando y proporcionando información de manera anónima.",
    items: [
      {
        label: "_ga, _ga_*",
        value: "_ga",
        isRequired: false,
      },
    ],
  },
];

const onAccept = (accepted) => {
  console.log("User accepted all cookies. 👍: " + accepted.join(", "));
  window.location.reload();
};

const onDecline = (required) => {
  console.log("User accepted no cookies. 👎: " + required.join(", "));
  window.location.reload();
};

const onSave = (accepted) => {
  console.log("User accepted the following cookies 📋: " + accepted.join(", "));
  window.location.reload();
};
</script>

<template>
  <VueCookieComply
    :preferences="preferences"
    :bannerTitle="'Configuración de las cookies'"
    bannerMaxWidth="6xl"
    :preferencesBtnLabel="'Configuración'"
    :savePreferencesBtnLabel="'Aceptar seleccionadas'"
    :acceptAllBtnLabel="'Aceptar todas'"
    :declineAllBtnLabel="'Rechazar todas'"
    :modalTitle="'Configuración de las cookies'"
    modalMaxWidth="xl"
    bgColor="#00a12e"
    @on-accept-all="onAccept"
    @on-decline-all="onDecline"
    @on-save-preferences="onSave"
  >
    <template #banner-text="{ title }">
      <h3 class="font-semibold">{{ title }}</h3>
      <p class="text-sm">
        Utilizamos cookies propias y de terceros para mejorar su experiencia y
        nuestros servicios, analizando la navegación en nuestro Sitio Web.
        Puedes aceptar todas las cookies o seleccionarlas según su categoria.
        Puede obtener más información en nuestra
        <RouterLink to="/politica-cookies" class="underline"
          >política de cookies</RouterLink
        >.
      </p>
    </template>
  </VueCookieComply>
</template>
